import { html, nothing } from "lit";
import type { CSSResultGroup } from "lit";

import { customElement, property, query } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

import { checkboxStyles } from "./checkbox.css.ts";

import "../field-wrapper/field-wrapper.ts";
import { ToggleBase } from "../toggle-base/toggle-base.ts";

@customElement("wow-checkbox")
export class Checkbox extends ToggleBase {
  static override styles: CSSResultGroup = [checkboxStyles];

  @query("input") private inputEl!: HTMLInputElement;

  @property({ type: Boolean, reflect: true }) switch = false;
  @property() label = "";
  @property({ attribute: "help-text" }) helpText = "";
  @property() override title = "";
  @property({ type: Boolean, reflect: true }) required = false;

  public override focus() {
    this.inputEl?.focus();
  }
  public setError(msg: string) {
    this._internals.setValidity({ customError: true }, msg, this.inputEl);
  }
  public clearError() {
    this._internals.setValidity({});
  }

  private handleChange = (e: Event): void => {
    const el = e.target as HTMLInputElement;
    this.updateStateFromEvent(el);

    if (el.checkValidity()) {
      this.clearError();
    } else {
      this.setError(el.validationMessage);
    }

    this.dispatchEvent(new Event("change", { bubbles: true }));
  };

  override render() {
    return html`
      <wow-field-wrapper inputType=${!this.switch ? "checkbox" : "switch"}>
        ${this.label ? html`<label class="label" slot="label" for=${this.id}>${this.label}</label>` : nothing}
        ${this.helpText ? html`<span slot="help" class="help-text">${this.helpText}</span>` : nothing}

        <span
          slot="control"
          class=${classMap({
            "fake-checkbox": !this.switch,
            "fake-switch": this.switch,
          })}
        >
          <input
            id=${this.id}
            part="checkbox"
            type="checkbox"
            name=${this.name}
            title=${this.title}
            ?disabled=${this.disabled}
            ?required=${this.required && !!this.name}
            .checked=${this.checked}
            class=${classMap({ checkbox: true, invalid: !!this.validationMessage })}
            @change=${this.handleChange}
          />
        </span>

        ${this.validationMessage
          ? html`<span class="error-message" slot="error">${this.validationMessage}</span>`
          : nothing}
      </wow-field-wrapper>
    `;
  }
}
